import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgHotel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#17181A"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3 6.5h-.5v-2h19v2h-1v13h-7v-3h-3v3h-7v-13H3Z" />
    <path d="M5.5 6.5h3v3h-3zm0 5h3v3h-3zm5-5h3v3h-3zm0 5h3v3h-3zm5-5h3v3h-3zm0 5h3v3h-3z" />
  </svg>
);
const Memo = memo(SvgHotel);
export default Memo;
